export const REFERRAL_TYPEFORM_URL = 'https://telavita.typeform.com/to/DlsNdnfK'
